import styled from "styled-components";

import {
  colors,
  stylesGlobalDefault as globalStyle,
} from "../../global/globalStyle";

interface IInfoAreaButtonClickCard {
  width?: number;
  heigth?: number;
  disabled?: boolean;
}

interface ICircleButtonClickCard {
  selected?: boolean;
  disabled?: boolean;
}

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;

  img {
    margin-right: 12px;
  }
`;

export const IconButtonClickCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-right: 12px;
  flex: 0 0 40px;

  img {
    margin-right: 0;
  }
`;

export const TextButtonClickCard = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;

  > div {
    min-width: 0;
  }

  .MuiTypography-root {
    max-width: 100%;
    min-width: 0;
  }

  .MuiBox-root {
    overflow: hidden;
    overflow-wrap: anywhere;
    text-overflow: ellipsis;
  }

  .MuiTypography-root:first-child .MuiBox-root {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 0 0 auto;
  gap: 40px;
  strong {
    font-family: ${globalStyle.fontFamily};
    font-weight: 400;
    color: ${colors.neutral_gray_40};
    font-size: 12px;
    line-height: 14.52px;

    @media screen and (max-width: 580px) {
      display: none;
    }
  }

  #status_badge {
    @media screen and (max-width: 475px) {
      display: none;
    }
  }
`;

export const InfoAreaButtonClickCard = styled.div<IInfoAreaButtonClickCard>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${colors.primary_default};
  width: ${(props) => props.width ?? "40px"};
  height: ${(props) => props.heigth ?? "40px"};
  flex: 0 0 ${(props) => props.width ?? "40px"};
  border-radius: 30px;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;

export const CircleButtonClickCard = styled.div<ICircleButtonClickCard>`
  width: ${(props) => (props.selected ? "8px" : "20px")};
  height: ${(props) => (props.selected ? "8px" : "20px")};
  border-radius: 50%;
  margin-right: 10px;
  background: ${colors.neutral_white};
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  border: ${(props) =>
    props.selected
      ? `8px solid ${colors.primary_default}`
      : `2px solid ${colors.neutral_gray_80}`};
`;
